import { Button } from '@mui/material';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { MemoPlusIcon } from 'components/core/PlusIcon';
import useIsMobile from 'hooks/useIsMobile';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { Color } from 'shared/utils/colors';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import { MemoForbiddenTooltip } from '../ForbiddenTooltip/ForbiddenTooltip';
import { useStyles } from './styles';
import { ButtonPlusCreateProps } from './types';

function ButtonPlusCreate(props: ButtonPlusCreateProps): ReactElement {
  const isMobile = useIsMobile();
  const {
    id,
    textId,
    canCreate,
    creationAction,
    dataQaId,
    glyphColor: enabledGlyphColor = Color.black,
  } = props;
  const intl = useIntl();

  const { reason, permission } = canCreate();
  const disabled = !permission;
  // A disabled CTA keeps the neutral black glyph.
  const glyphColor = disabled ? Color.black : enabledGlyphColor;
  const classes = useStyles({ isMobile, glyphColor });
  const CREATE_TEXT = formatTranslation(intl, unsafeTranslationKey(textId) );

  return (
    <MemoForbiddenTooltip visibleWhen={disabled} reason={reason} inlined>
      {isMobile ? (
        <ButtonIcon
          disabled={disabled}
          id={id}
          data-qa={dataQaId}
          onClick={creationAction}
          className={classes.iconButton}
        >
          <MemoPlusIcon
            disabled={disabled}
            badgeColor='transparent'
            glyphColor={glyphColor}
          />
        </ButtonIcon>
      ) : (
        <Button
          className={classes.button}
          disabled={disabled}
          variant='outlined'
          color='inherit'
          id={id}
          data-qa={dataQaId}
          onClick={creationAction}
          startIcon={<MemoPlusIcon disabled={disabled} />}
        >
          {CREATE_TEXT}
        </Button>
      )}
    </MemoForbiddenTooltip>
  );
}

export const MemoButtonPlusCreate = React.memo(ButtonPlusCreate);
